import React from 'react'

const TesisGecirilenSure75 = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={width}
      height={height}
      viewBox='0 0 65.168 65.168'
    >
      <defs>
        <linearGradient
          id='linearGradient'
          x1='0.055'
          y1='0.731'
          x2='0.939'
          y2='0.294'
          gradientUnits='objectBoundingBox'
        >
          <stop offset='0' stopColor='#2fc824' />
          <stop offset='0.397' stopColor='#cec32b' />
          <stop offset='0.699' stopColor='#ff8120' />
          <stop offset='1' stopColor='#b5b5b5' />
        </linearGradient>
      </defs>
      <path
        id='_3'
        dataname='3'
        d='M32.584,5.266A27.318,27.318,0,1,0,59.9,32.584,27.349,27.349,0,0,0,32.584,5.266m0-5.266A32.584,32.584,0,1,1,0,32.584,32.584,32.584,0,0,1,32.584,0Z'
        fill='url(#linearGradient)'
      />
    </svg>
  )
}

export default TesisGecirilenSure75
